import React, { Dispatch, forwardRef, SetStateAction } from "react";
import Delete from "./SVGIcons/Delete";
import Edit from "./SVGIcons/Edit";
import sidebarTranslation from "../locales/sidebar.json";
import { useAppContext } from "../hooks/useAppContext";

type Props = {
  setRenameChat: Dispatch<SetStateAction<boolean>>;
  handleConversationDelete: () => void;
  onMouseLeave: () => void;
};

const SideBarHistoryMenu = forwardRef<HTMLUListElement, Props>(
  ({ setRenameChat, handleConversationDelete, onMouseLeave }: Props, ref) => {
    const { locale } = useAppContext();

    return (
      <ul
        className={`absolute right-[0px] top-[20px] z-10 flex flex-col rounded-s-[14px] rounded-br-[14px] bg-grayscale-solid-elevate-level1 p-2 shadow-md`}
        ref={ref}
        onMouseLeave={onMouseLeave}
      >
        <li
          className="flex w-full items-center gap-2 rounded-[10px] p-2 hover:bg-grayscale-solid-g3"
          onClick={() => setRenameChat(true)}
        >
          <Edit className="flex-shrink-0 fill-grayscale-solid-g10" />
          <span className="whitespace-nowrap text-[12px] font-medium leading-[19px] text-grayscale-solid-g10">
            {sidebarTranslation["Rename"][locale]}
          </span>
        </li>
        <li
          className="flex w-full items-center gap-2 rounded-[10px] p-2 text-grayscale-solid-g5 hover:bg-red-opacity-level2"
          onClick={handleConversationDelete}
        >
          <Delete className="flex-shrink-0" />
          <span className="whitespace-nowrap text-[12px] font-medium leading-[19px] text-red-solid-red5">
            {sidebarTranslation["Delete"][locale]}
          </span>
        </li>
      </ul>
    );
  },
);

export default SideBarHistoryMenu;
